<template>
  <div
      v-if="computedActiveNavItems.length"
      class="nav">
    <ul>
      <li
          v-for="(navItem, index) in computedActiveNavItems"
          :key="index"
      >
        <router-link
            :to="'/' + navItem[0]"
            :class="navItem[0]"
        >
          <!-- icons for specific nav item -->
          <svg
              v-if="navItem[0] === 'tip'"
              class="nav_icon"
              width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M18 13.8458C18 18.0914 14.2499 20 9 20C3.75012 20 0 18.0914 0 13.8758C0 9.2601 2.25035 6.92155 6.74965 4.583L5.15658 1.53874C5.06153 1.38626 5.0086 1.21018 5.00344 1.02926C4.99828 0.848349 5.04107 0.669389 5.12726 0.511466C5.21345 0.353543 5.3398 0.222578 5.49285 0.132535C5.64589 0.0424918 5.81989 -0.00325238 5.99629 0.000179873H12.356C12.5214 0.00451982 12.6829 0.0519462 12.8255 0.137996C12.968 0.224045 13.0869 0.345887 13.1708 0.492056C13.2548 0.638224 13.3012 0.803911 13.3055 0.973523C13.3099 1.14314 13.2721 1.3111 13.1957 1.4616L11.2503 4.583C15.7483 6.89012 18 9.22867 18 13.8458ZM9.87034 6.98155C9.87034 6.74475 9.77864 6.51765 9.61542 6.35021C9.4522 6.18276 9.23083 6.0887 9 6.0887C8.76917 6.0887 8.5478 6.18276 8.38458 6.35021C8.22136 6.51765 8.12966 6.74475 8.12966 6.98155V7.87725C7.53976 7.90057 6.97844 8.14401 6.55113 8.56186C6.12382 8.97971 5.85991 9.54322 5.80896 10.1466C5.75801 10.7499 5.92353 11.3516 6.27443 11.8386C6.62533 12.3256 7.13748 12.6645 7.71468 12.7915L9.7659 13.2515C9.97614 13.2979 10.1622 13.4226 10.2881 13.6014C10.4141 13.7802 10.4711 14.0005 10.4481 14.2199C10.4251 14.4392 10.3237 14.6421 10.1635 14.7893C10.0034 14.9365 9.79575 15.0177 9.58069 15.0172H8.41931C8.23926 15.0175 8.06356 14.9605 7.91641 14.854C7.76927 14.7476 7.65792 14.597 7.59771 14.4229C7.56255 14.3087 7.50535 14.2029 7.42951 14.1118C7.35367 14.0208 7.26075 13.9463 7.15627 13.8928C7.0518 13.8394 6.9379 13.808 6.82137 13.8006C6.70484 13.7933 6.58805 13.81 6.47796 13.8499C6.36787 13.8898 6.26673 13.952 6.18056 14.0328C6.09438 14.1136 6.02494 14.2114 5.97636 14.3203C5.92778 14.4292 5.90105 14.547 5.89778 14.6667C5.8945 14.7865 5.91474 14.9057 5.95729 15.0172C6.12099 15.4916 6.41153 15.9092 6.79569 16.2222C7.17986 16.5352 7.64213 16.731 8.12966 16.7872V17.6957C8.12966 17.9325 8.22136 18.1596 8.38458 18.3271C8.5478 18.4945 8.76917 18.5886 9 18.5886C9.23083 18.5886 9.4522 18.4945 9.61542 18.3271C9.77864 18.1596 9.87034 17.9325 9.87034 17.6957V16.7872C10.4848 16.7155 11.0546 16.4226 11.4783 15.9604C11.9019 15.4983 12.1521 14.8969 12.1842 14.2634C12.2162 13.6298 12.0282 13.0051 11.6535 12.5004C11.2787 11.9958 10.7416 11.6438 10.1377 11.5072L8.08649 11.0472C7.92007 11.0123 7.77234 10.9149 7.67219 10.7741C7.57203 10.6334 7.52666 10.4594 7.54494 10.2861C7.56323 10.1129 7.64384 9.95283 7.77104 9.83732C7.89823 9.72181 8.06285 9.65913 8.23271 9.66152H9.58069C9.76088 9.6606 9.93686 9.71735 10.0841 9.82387C10.2314 9.9304 10.3426 10.0814 10.4023 10.2558C10.4833 10.4735 10.644 10.6501 10.8502 10.7479C11.0564 10.8457 11.2917 10.8569 11.5059 10.7791C11.72 10.7014 11.896 10.5408 11.9963 10.3317C12.0966 10.1226 12.1133 9.8816 12.0427 9.66009C11.8792 9.18565 11.5887 8.76808 11.2045 8.45528C10.8203 8.14247 10.3579 7.94709 9.87034 7.89154V6.98155Z"
                  fill="#999999"/>
          </svg>
          <svg
              v-else-if="navItem[0] === 'menu'"
              class="nav_icon"
              width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.07715 19.0654C1.47949 18.96 1.02539 18.7314 0.714844 18.3799C0.410156 18.0283 0.257812 17.5566 0.257812 16.9648V4.81836C0.257812 4.36133 0.354492 3.97754 0.547852 3.66699C0.74707 3.35059 1.01953 3.125 1.36523 2.99023C1.7168 2.84961 2.12109 2.82031 2.57812 2.90234L11.9824 4.56348C12.9082 4.72754 13.5996 5.01758 14.0566 5.43359C14.5137 5.84961 14.7422 6.51758 14.7422 7.4375V18.0459C14.7422 18.7139 14.6221 19.2705 14.3818 19.7158C14.1416 20.167 13.7988 20.4834 13.3535 20.665C12.9082 20.8467 12.3779 20.8848 11.7627 20.7793L2.07715 19.0654ZM3.81738 8.14941L10.6201 9.35352C10.8545 9.39453 11.042 9.35059 11.1826 9.22168C11.3232 9.09277 11.3936 8.92285 11.3936 8.71191C11.3936 8.34277 11.2119 8.12012 10.8486 8.04395L4.08984 6.85742C3.85547 6.81641 3.66211 6.85742 3.50977 6.98047C3.36328 7.10352 3.29004 7.27051 3.29004 7.48145C3.29004 7.65723 3.33398 7.80664 3.42188 7.92969C3.51562 8.05273 3.64746 8.12598 3.81738 8.14941ZM3.81738 11.7529L10.6201 12.9658C10.8545 13.0068 11.042 12.9629 11.1826 12.834C11.3232 12.7051 11.3936 12.5322 11.3936 12.3154C11.3936 11.9404 11.2119 11.7207 10.8486 11.6562L4.08984 10.4697C3.85547 10.4346 3.66211 10.4785 3.50977 10.6016C3.36328 10.7188 3.29004 10.8799 3.29004 11.085C3.29004 11.2607 3.33691 11.4102 3.43066 11.5332C3.52441 11.6562 3.65332 11.7295 3.81738 11.7529ZM4.74902 2.04102L10.6465 1.00391C11.7305 0.810547 12.5859 0.930664 13.2129 1.36426C13.8457 1.79199 14.1709 2.48047 14.1885 3.42969L14.1973 4.01855C13.6523 3.71387 12.9873 3.49121 12.2021 3.35059L4.74902 2.04102Z"
                fill="#999999"/>
          </svg>
          <svg
              v-else-if="navItem[0] === 'bill'"
              class="nav_icon"
              width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.1597 2.3788C11.179 2.35447 11.2031 2.33433 11.2305 2.31961C11.2578 2.30488 11.2879 2.29587 11.3188 2.29312C11.3498 2.29038 11.381 2.29396 11.4105 2.30365C11.44 2.31333 11.4673 2.32892 11.4906 2.34947L12.3358 3.0938L9.67743 6.41672H11.4374L13.3679 4.00405L14.8823 5.33963C14.927 5.3792 14.9546 5.4347 14.959 5.49429C14.9635 5.55388 14.9445 5.61285 14.9061 5.65863L14.2736 6.41672H16.0556C16.2763 6.09357 16.3713 5.70088 16.3227 5.31257C16.2741 4.92427 16.0852 4.56712 15.7916 4.30838L12.3999 1.3173C12.2363 1.1732 12.045 1.06397 11.8378 0.996276C11.6305 0.928581 11.4117 0.903844 11.1945 0.923575C10.9774 0.943307 10.7666 1.00709 10.5749 1.11104C10.3833 1.21498 10.2148 1.3569 10.0798 1.52813L6.22802 6.41672H7.97885L11.1597 2.3788ZM2.81252 5.95838C2.63018 5.95838 2.45531 6.03082 2.32638 6.15975C2.19745 6.28868 2.12502 6.46355 2.12502 6.64588C2.12502 6.82822 2.19745 7.00309 2.32638 7.13202C2.45531 7.26095 2.63018 7.33338 2.81252 7.33338H14.7292C15.5193 7.33338 16.2771 7.64726 16.8358 8.20596C17.3945 8.76466 17.7083 9.52243 17.7083 10.3125V16.2709C17.7083 17.061 17.3945 17.8188 16.8358 18.3775C16.2771 18.9362 15.5193 19.25 14.7292 19.25H3.72918C2.93906 19.25 2.1813 18.9362 1.62259 18.3775C1.06389 17.8188 0.750015 17.061 0.750015 16.2709V6.64588C0.750015 6.09887 0.967314 5.57427 1.35411 5.18748C1.7409 4.80068 2.26551 4.58338 2.81252 4.58338H6.77252L5.67985 5.95838H2.81252ZM12.2083 13.5209C12.2083 13.9004 12.5163 14.2084 12.8958 14.2084H14.7292C14.9115 14.2084 15.0864 14.136 15.2153 14.007C15.3442 13.8781 15.4167 13.7032 15.4167 13.5209C15.4167 13.3385 15.3442 13.1637 15.2153 13.0347C15.0864 12.9058 14.9115 12.8334 14.7292 12.8334H12.8958C12.7135 12.8334 12.5386 12.9058 12.4097 13.0347C12.2808 13.1637 12.2083 13.3385 12.2083 13.5209Z"
                fill="#999999"/>
          </svg>
          <svg
              v-else-if="navItem[0] === 'review'"
              class="nav_icon"
              width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 15.0745L13.3649 17.8368C14.1642 18.343 15.1424 17.5947 14.932 16.6482L13.7751 11.4537L17.6351 7.95405C18.3398 7.31575 17.9611 6.10517 17.0356 6.02813L11.9555 5.57692L9.96763 0.66857C9.61003 -0.222857 8.38997 -0.222857 8.03237 0.66857L6.04451 5.56591L0.964434 6.01713C0.038871 6.09416 -0.339768 7.30474 0.364921 7.94305L4.22494 11.4427L3.06799 16.6372C2.85763 17.5837 3.83578 18.332 4.63513 17.8258L9 15.0745Z"
                fill="#999999"/>
          </svg>

          <!-- arrow for welcome page -->
          <svg
              class="nav_arrow"
              width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.41342 2.61247C7.08535 2.94065 6.90105 3.38569 6.90105 3.84972C6.90105 4.31376 7.08535 4.7588 7.41342 5.08697L16.0759 13.7495L7.41342 22.412C7.09465 22.742 6.91826 23.1841 6.92224 23.6429C6.92623 24.1018 7.11028 24.5407 7.43474 24.8652C7.7592 25.1896 8.19813 25.3737 8.65697 25.3777C9.11582 25.3816 9.55787 25.2052 9.88792 24.8865L19.7877 14.9867C20.1157 14.6586 20.3 14.2135 20.3 13.7495C20.3 13.2854 20.1157 12.8404 19.7877 12.5122L9.88792 2.61247C9.55975 2.2844 9.11471 2.1001 8.65067 2.1001C8.18664 2.1001 7.7416 2.2844 7.41342 2.61247Z"
                fill="#661DDE"/>
          </svg>
          <p>
            {{ $t(`nav.${navItem[0]}.title`) }}
            <!--<span>{{ $t(`nav.${navItem[0]}.subtitle`) }}</span>-->
          </p>
          <p class="badge" v-if="navItem[0] === 'bill' && countCartItems > 0">{{ countCartItems }}</p>
        </router-link>
      </li>
      <li class="menu-info">
        <a href="" @click="openHelpSlides">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C23.9966 8.81843 22.7313 5.76814 20.4816 3.51843C18.2319 1.26872 15.1816 0.00335979 12 0ZM11.5385 5.53846C11.8123 5.53846 12.08 5.61967 12.3077 5.77181C12.5354 5.92395 12.7129 6.1402 12.8177 6.39321C12.9225 6.64621 12.9499 6.92461 12.8965 7.1932C12.843 7.46179 12.7112 7.7085 12.5175 7.90215C12.3239 8.09579 12.0772 8.22766 11.8086 8.28109C11.54 8.33451 11.2616 8.30709 11.0086 8.20229C10.7556 8.0975 10.5393 7.92002 10.3872 7.69233C10.2351 7.46463 10.1538 7.19693 10.1538 6.92308C10.1538 6.55585 10.2997 6.20367 10.5594 5.944C10.8191 5.68434 11.1712 5.53846 11.5385 5.53846ZM12.9231 18.4615C12.4334 18.4615 11.9639 18.267 11.6177 17.9208C11.2714 17.5746 11.0769 17.105 11.0769 16.6154V12C10.8321 12 10.5973 11.9027 10.4242 11.7296C10.2511 11.5565 10.1538 11.3217 10.1538 11.0769C10.1538 10.8321 10.2511 10.5973 10.4242 10.4242C10.5973 10.2511 10.8321 10.1538 11.0769 10.1538C11.5666 10.1538 12.0361 10.3483 12.3824 10.6946C12.7286 11.0408 12.9231 11.5104 12.9231 12V16.6154C13.1679 16.6154 13.4027 16.7126 13.5758 16.8857C13.7489 17.0589 13.8462 17.2936 13.8462 17.5385C13.8462 17.7833 13.7489 18.0181 13.5758 18.1912C13.4027 18.3643 13.1679 18.4615 12.9231 18.4615Z" fill="#999999"/>
        </svg>
        <p>
          Info
        </p>
        </a>
      </li>
    </ul>
    <div class="welcome-info" @click="openHelpSlides">
        🤓  <span>{{ $t('faqSlides.howItWork') }}</span>
    </div>
  </div>

</template>

<script>

export default {
  name: "VNav",
  emits: ['showHelp'],
  computed: {
    computedActiveNavItems: function () {
      let navItems = this.$store.getters['getCompanyData'].locale.nav_items

      return Object.entries(navItems)
          .filter(item => {
            if (item[0] === 'bill') {
              return this.$store.getters['getTableNum'] !== null || this.$store.getters['getCartEnabled'];
            }
            return item[1];
          });
    },
    computedCart: function () {
      // console.log(this.$store.getters['cartStore/getCart'])
      return this.$store.getters['cartStore/getCart']
    },
    countCartItems() {
      let amount = 0,
          orders = this.computedCart

      if (orders.length) {
        orders.forEach(item => {
              amount += item.count
            })
      }
      return amount;
    },

  },
  methods: {
    openHelpSlides(e) {

      e.preventDefault();
      this.$emit('showHelp')
    }
  }
}
</script>

<style>
.badge {
  padding: 0;
  background-color: #c04222;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  font-size: 8px;
  margin-left: 30px !important;
  margin-top: -5px !important;
  z-index: 1;
  position: absolute;
}

.welcome-info {
  display: none;

  span {
    text-decoration: underline;
  }
}

</style>
<!--<style lang="scss" scoped>-->
<!--@import "/src/scss/assets/variables";-->

<!--.nav {-->
<!--  flex: 1 1;-->
<!--  background-color: rgba(0, 0, 0, 0);-->

<!--  ul {-->
<!--    display: flex;-->
<!--    flex-direction: column;-->
<!--    gap: 16px;-->
<!--    flex: 1 1;-->
<!--    padding: 0 9px;-->

<!--    li {-->
<!--      width: 100%;-->
<!--      flex: 1 1;-->

<!--      a {-->
<!--        font-size: 24px;-->
<!--        width: 100%;-->
<!--        justify-content: space-between;-->
<!--        flex-direction: row-reverse;-->
<!--        align-items: center;-->
<!--        border-radius: 12px;-->
<!--        height: 100%;-->
<!--        padding: 12px 24px;-->
<!--        background-color: $color_white_titan;-->


<!--        p {-->
<!--          margin: 0;-->
<!--          display: flex;-->
<!--          flex-direction: column;-->
<!--          gap: 5px;-->
<!--          font: {-->
<!--            weight: 700;-->
<!--          };-->

<!--          .badge {-->
<!--            padding: 0;-->
<!--            background-color: #c04222;-->
<!--            border-radius: 50%;-->
<!--            height: 20px;-->
<!--            width: 20px;-->
<!--            font-size: 8px;-->
<!--            margin-left: -10px;-->
<!--            margin-top: -10px;-->
<!--            z-index: 1;-->
<!--          }-->

<!--          color: $color_black;-->

<!--          span {-->
<!--            display: flex;-->
<!--            color: $color_grey_dusty;-->
<!--            font: {-->
<!--              size: 14px;-->
<!--            };-->
<!--            letter-spacing: 1px;-->
<!--          }-->
<!--        }-->

<!--        svg {-->
<!--          &:is(.nav_icon) {-->
<!--            display: none;-->
<!--          }-->

<!--          &:is(.nav_arrow) {-->
<!--            display: flex;-->
<!--          }-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--}-->


<!--</style>-->
